import { FormRadioButton, FormRadioGroup } from "@jsq/ds/forms";
import { DATE_TYPE_OPTIONS } from "./constants";

type DateTypeRadioProps = {
  /** Formik field name pointing at the `DateType` value. */
  name: string;
  isReadOnly?: boolean;
};

/** Shared "GL date / Effective date" radio group, rendered for every variant.
 * Options may be individually disabled (e.g. "Effective date" for the MVP). */
export const DateTypeRadio = ({ name, isReadOnly = false }: DateTypeRadioProps) => (
  <FormRadioGroup name={name} label="Date type" data-testid="date-type-radio">
    {DATE_TYPE_OPTIONS.map((option) => (
      <FormRadioButton
        key={option.value}
        value={option.value}
        disabled={isReadOnly || option.disabled === true}
      >
        {option.label}
      </FormRadioButton>
    ))}
  </FormRadioGroup>
);
